module.exports = __webpack_public_path__ + "img/Shapezio-large.cdcc0276.png";